import { useContext, useState, useEffect } from 'react';
import PersonalHeader from '../../PersonalDetails/components/header';
// import TableComponent from '../../TableComponent';
import FormGroup from '../../FormGroup';
import useFetchData from '../../../hooks/useFetchData';
import usePostData from '../../../hooks/usePostData';
import fields from '../fields';
import GlobalContext from '../../../contexts';
import { useParams } from 'react-router-dom';
import translating from '../translate.json';
import { find } from 'lodash';
import SnackBar from 'components/SnackBar';

const ProductPage = () => {
  // const navigate = useNavigate()
  const { id } = useParams();
  const { postData, res, payload } = usePostData();
  const { categoriesList, organizationsList } = useContext(GlobalContext);
  const [currentProduct, setCurrentproduct] = useState({});
  const [showSnackbar, setShowSnakbar] = useState(false);

  let { data: productData } = useFetchData('product', id);

  useEffect(() => {
    if (productData) {
      productData.discountMaxValue =
        productData.discountType === 'אחוז'
          ? productData.maxPercentDiscountAmount
          : productData.maxFixedDiscountAmount;
      setCurrentproduct(productData);
    }
  }, [productData]);

  useEffect(() => {
    if (res && res.affected === 1 && payload) {
      console.log('udpated');
      setShowSnakbar(true);
    }
  }, [res, payload]);

  const onSubmit = (data) => {
    delete data.id;
    delete data.category;
    data.organization = find(organizationsList, { id: data.organizationId });
    if (data.discountType === 'אחוז') {
      data.maxPercentDiscountAmount = data.discountMaxValue;
      data.maxFixedDiscountAmount = data.price * (data.discountMaxValue / 100);
    } else {
      data.maxPercentDiscountAmount =
        (data.discountMaxValue / data.price) * 100;
      data.maxFixedDiscountAmount = data.discountMaxValue;
    }
    delete data.discountMaxValue;
    if (data.parentId === 1)
      data.numberOfAppointments = data.numberOfAppointments || 2;
    else if (data.parentId === 2) {
      data.numberOfAppointments = data.numberOfAppointments || 3;
    }
    console.log('update product data  :', data);
    postData(`product/${id}`, data, 'patch');
  };

  const actions = [];

  return (
    <div className="product-page">
      {currentProduct?.id && (
        <div>
          <div className="personal-details">
            <PersonalHeader
              title={translating.productDetailsHeader}
              actions={actions}
            ></PersonalHeader>
            <div className="wrapper-details">
              <div className="product-details">
                <FormGroup
                  fields={fields(categoriesList, true)}
                  data={currentProduct}
                  onSubmit={onSubmit}
                ></FormGroup>
              </div>
            </div>
          </div>
        </div>
      )}
      {showSnackbar && (
        <SnackBar
          msg={'מוצר עודכן'}
          handleClose={() => setShowSnakbar(false)}
        ></SnackBar>
      )}
    </div>
  );
};

export default ProductPage;
